import React, {useState} from 'react'
import Accordion from '@/scripts/components/shared/accordion-group/accordion'

export default function AccordionGroup(props) {

    const {
        closeSiblings,
        items,
        include_hr,
        openFirstAllowed
    } = props
    
    const initialOpen = () => {
        if (openFirstAllowed && items[0].open) {
            return closeSiblings ? items[0].id : [items[0].id]
        } else {
            return closeSiblings ? 0 : []
        }
    }
    
    const [currentlyOpen, setCurrentlyOpen] = useState(initialOpen)

    const notify_new_open = (item) => {
        if (closeSiblings) {
            setCurrentlyOpen(currentlyOpen === item ? 0 : item)
        } else {
            if (currentlyOpen.includes(item)) {
                setCurrentlyOpen(currentlyOpen.filter(id => id !== item))
            } else {
                setCurrentlyOpen([...currentlyOpen, item])
            }
        }
    }

    function is_item_open(item_id) {
        if (closeSiblings) {
            return currentlyOpen === item_id
        } else {
            return currentlyOpen.includes(item_id)
        }
    }

    return (
        <>
            {items.map(item => {
                return (
                    <Accordion
                        detailsClass={item.className}
                        key={item.id}
                        id={item.id}
                        summaryClass={item.summaryClass}
                        header={item.header}
                        headerClass={item.headerClass}
                        content={item.content}
                        contentClass={item.contentClass}
                        currentlyOpen={is_item_open(item.id)}
                        notify_parent={notify_new_open}
                        suppressHydrationWarning={true}
                        includeHr={include_hr}
                    />
                )
            })}
        </>
    )
}
